module.exports = __webpack_public_path__ + "static/media/2016.c54f5e63.csv";